/**
 * selection-form
 */

import Component from "../../js/lib/component";
import filter from "./filter/main";

/* global $ */

const classList = {
  root: ".js-selection-form"
};

export default class SelectionForm extends Component {
  init() {
    this.filter = filter;
  }
}

Component.mount(SelectionForm, {
  name: "SelectionForm",
  classList,
  state: {}
});
